import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

interface GetTissFields {
  organization?: string;
  practitionerId?: string;
  patientId?: string;
  appointmentId?: string;
  count?: number;
}

export async function GetTiss({
  organization,
  practitionerId,
  patientId,
  count,
}: GetTissFields) {
  let url = `${endpoints.TISS}/DocumentReference`;

  const queryParams: string[] = [];
  if (count) queryParams.push(`_count=${count}`);

  if (organization) queryParams.push(`author=Organization/${organization}`);

  if (queryParams.length > 0) {
    url = `${url}?${queryParams.join("&")}`;
  }

  const subjectId = await useAuth.getSubjectId();
  const organizationId = await useAuth.getOrganizationId();

  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
    "x-user-token": await useAuth.getXUserToken(),
    ...(subjectId && { "subject-id": subjectId }),
    ...(organizationId && { "organization-id": organizationId }),
    purposeofuse: "Atendimento",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Get Tiss: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetTiss ", error);
      // toast.error(`GetDocumentReference Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
